import React, { Component } from 'react'
import sha256 from 'js-sha256'
import axios from 'axios'
import LoadingSpinner from './Spinner'
import OverlayLoader from '../modalPopups/overlayLoader'

export class ProductPermissionSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productGroup: [],
      productGroupChecked: [],
      selectProductGroupId: [],
      isLoading: false,
      showUpdateButton: false,
      loadingText: '',
      addPermissionResultMessage: '',
      hash: sha256(this.props.searchterm),
      accessToken: localStorage.getItem("accessToken"),
      overLayPopupShow: false,
      overLayPopupText: ''
    }
  }


  handleOverylayModalShowClose = (modalStatus,modalText) => {
    this.setState(
      {
        overLayPopupShow: modalStatus,
        overLayPopupText: modalText
      }
    )
  }

  handleProdGroupSelect = (productGroupData) => {

    //Check if clicked checkbox is already selected
    var found = this.state.productGroupChecked.find((element) => {
      return element.productGroupId === productGroupData.productGroupId;
    });

    if(found){
      //If clicked checkbox already selected then remove that from productGroupChecked array
      this.setState(
          {
            selectProductGroupId: this.state.selectProductGroupId.filter(element => element !== productGroupData.productGroupId),
            productGroupChecked: this.state.productGroupChecked.filter(element => element.productGroupId !== productGroupData.productGroupId)
          }, () => {
            //console.log(this.state.productGroupChecked);
          }
      )
    }else{
      //If clicked checkbox is not already selected then add that in productGroupChecked array
      this.setState(
        {
          selectProductGroupId: [...this.state.selectProductGroupId, productGroupData.productGroupId],
          productGroupChecked: [...this.state.productGroupChecked,productGroupData]
        }, () => {
          //console.log(this.state.selectProductGroupId);console.log(this.state.productGroupChecked);
        }
      )
    }
  }


  // Call All Product Groups
  fetchProdGroupUrl = (URl) => {
    axios.get(URl, {				
      headers: {
        'Authorization': `Bearer ${this.state.accessToken}`
      },
    })
    .then(result => {
      this.setState({isLoading : false})
      this.handleOverylayModalShowClose(false,'')
      if(result.data.status === 'success')
      {
        //this.setState({productGroup : result.data.data})

        var newProductGroup = [];
        
        result.data.data.forEach((productGroupData, i)=>{
          
          newProductGroup.push({
                              productGroupId:productGroupData.id,
                              name:productGroupData.name
                            })
        })
        
        this.setState(
          {
            productGroup: newProductGroup,
          }
        )
        this.handleOverylayModalShowClose(true,'Members Product Access Data Loading... Please Wait')
        this.setState({isLoading : true})
        this.setState({loadingText : 'Fetching Members Product Access'})
        this.fetchMembersProdGroupUrl(`${process.env.REACT_APP_CSAPI_BASE_URL}/member/permissions?hash=${this.state.hash}`)
        this.setState({showUpdateButton: true})
        
      }
    })
    .catch((error) => {
      // Error
      if(error.response.status === 401)
      {
        localStorage.clear()
        this.props.navigate("/login")
      }
      this.handleOverylayModalShowClose(false,'')
    });
  }


  // Call Members Product Permissions
  fetchMembersProdGroupUrl = (URl) => {
    axios.get(URl, {				
      headers: {
        'Authorization': `Bearer ${this.state.accessToken}`
      },
    })
    .then(result => {
      this.setState({isLoading : false})
      this.handleOverylayModalShowClose(false,'')
      if(result.data.status === 'success')
      {
        this.setState({productGroupChecked : result.data.data})
        this.setState({showUpdateButton: true})
      }
    })
    .catch((error) => {
      // Error
      this.handleOverylayModalShowClose(false,'')
      if(error.response.status === 401)
      {
        localStorage.clear()
        this.props.navigate("/login")
      }
    });
  }

  // Update Members Product Permissions
  UpdateMembersProdPermission = (URl, postData) => {
    axios.post(URl, postData, {				
      headers: {
        'Authorization': `Bearer ${this.state.accessToken}`
      },
    })
    .then(result => {      
      this.setState({isLoading : false})
      if(result.data.status === 'success')
      {
        this.setState({addPermissionResultMessage : 'Product Permission has been updated'})        
      }
    })
    .catch((error) => {
      // Error
      if(error.response.status === 401)
      {
        localStorage.clear()
        this.props.navigate("/login")
      }
    });
  }

  // update permission when update perission button clicked
  updatePermission = ()=> {
    //console.log(this.state.productGroupChecked);

    const productGroupSelectedIds = []

    this.state.productGroupChecked.forEach((product, index) => {
      productGroupSelectedIds.push(product.productGroupId)
    });

    const postData = {productGroupId: productGroupSelectedIds};

    this.UpdateMembersProdPermission(`${process.env.REACT_APP_CSAPI_BASE_URL}/member/permissions?hash=${this.state.hash}`,postData)
    console.log(productGroupSelectedIds.length);

  }

  

  componentDidMount() {

      this.setState({isLoading : true})
      this.setState({loadingText : 'Fetching Products Group'})
      this.handleOverylayModalShowClose(true,'Products Group Data Loading... Please Wait')
      this.fetchProdGroupUrl(`${process.env.REACT_APP_CSAPI_BASE_URL}/product-groups?hash=${this.state.hash}`);
  }
    
  render() {
      return (
        
            <div className="app-wrapper">
              <div className="app-content pt-3 p-md-3 p-lg-4 ">
                  <div className="container-xl">
                  <OverlayLoader 
                    show={this.state.overLayPopupShow}
                    title=''
                    body={this.state.overLayPopupText} 
                  />
                    <div className="app-content pt-3 mb-5">
                          {this.props.searchterm ? (
                              <h3>
                                  Search: <code>{this.props.searchterm}</code>
                              </h3>
                          ) : (
                              <h3>There is no name in the query string</h3>
                          )}                
                      </div>
                      <div className="col-auto">
                          <h1 className="app-page-title mb-0">Products Permission</h1>
                          <hr className="mb-4" />
                      </div>
                      {this.state.addPermissionResultMessage &&
                          <div className="col-md-7 alert alert-success alert-dismissible fade show" role="alert">
                              {this.state.addPermissionResultMessage}
                          </div>
                      }
                      <div className="table-responsive">
                      {this.state.isLoading ? <LoadingSpinner loadingText={this.state.loadingText} /> : ''}
                      <table className="table table-hover table-bordered border-success">
                        <thead>
                          <tr>
                            <th colSpan={2}>The customer has access to:</th>
                          </tr>
                        </thead>
                        <tbody>
                          

                        {this.state.productGroup.map(productGroupData => (
                          
                          <tr key={productGroupData.productGroupId}  className="form-switch">
                            <td style={{backgroundColor: this.state.productGroupChecked.some(({ productGroupId}) => productGroupId === productGroupData.productGroupId) ? "#DFF0D8" : "" }}>
                              {productGroupData.name}
                            </td>
                            <td align="right" style={{backgroundColor: this.state.productGroupChecked.some(({ productGroupId}) => productGroupId === productGroupData.productGroupId) ? "#DFF0D8" : "" }}>
                              <input className="form-check-input" type="checkbox" 
                                id={productGroupData.productGroupId}
                                checked={this.state.productGroupChecked.some(({ productGroupId}) => productGroupId === productGroupData.productGroupId)}
                                onChange = {() => this.handleProdGroupSelect(productGroupData)}
                              />
                            </td>
                          </tr>                        
                        ))}
                          <tr><td colSpan={2}>&nbsp;</td></tr>
                              {this.state.showUpdateButton === true ?
                                  <tr>
                                    <td colSpan="2" align="right"><button type="submit" className="btn btn-success" onClick={this.updatePermission}>Update Permissions</button>
                                  </td>
                                  </tr>
                              : '' }
                        </tbody>
                      </table>
                      </div>

                  </div>     
              </div>
          </div>
        
      )
  }
}

export default ProductPermissionSection
